

















































































import Vue from 'vue';
import VueCompositionAPI, {
  defineComponent,
  computed,
} from '@vue/composition-api';
import { useRouter, RouterAliases } from '@/router';
import {
  getWaitTime,
  getCovidBedsReport,
  getICUBedsReport,
  getAvailableVentilatorsReport,
  getTotalVentilatorsReport,
  getAdditionalComments,
  submitReport,
} from '../store';
Vue.use(VueCompositionAPI);

const HandleEmpty = (inp: number | ''): string => {
  if (inp === -1 || inp === '') {
    return '?';
  } else {
    return inp.toString();
  }
};

const Hospitals = (hospitalId: string) => {
  /* eslint-disable */
  // @ts-ignore
  window.gtag &&
    // @ts-ignore
    gtag('config', process.env.VUE_APP_GOOGLE_ANALYTICS_TRACKING_ID, {
      page_path: `report-summary/${hospitalId}`,
      app_name: 'Patients Care',
    });
  /* eslint-enable */

  const saveReport = () => {
    const router = useRouter();
    submitReport(hospitalId);
    router.push({
      name: RouterAliases.THANK_YOU,
    });
  };

  const waitTime = computed(() => {
    const value = getWaitTime();
    const hours = Math.floor(+value.value / 60);
    const minutes = +value.value - hours * 60;
    return hours ? `${hours}h` : `${minutes}m`;
  });

  const availableCoronaBeds = computed(() => {
    const value = getCovidBedsReport();
    return value.value;
  });

  const availableICUBends = computed(() => {
    const value = getICUBedsReport();
    return value.value;
  });

  const availableVentilators = computed(() => {
    const value = getAvailableVentilatorsReport();
    return value.value;
  });
  const totalVentilators = computed(() => {
    const value = getTotalVentilatorsReport();
    return value.value;
  });
  const comments = computed(() => {
    return getAdditionalComments();
  });

  const back = () => {
    window.history.back();
  };

  return {
    waitTime,
    back,
    HandleEmpty,
    availableCoronaBeds,
    availableICUBends,
    availableVentilators,
    totalVentilators,
    comments,
    saveReport,
  };
};

const ReportSummary = defineComponent({
  props: {
    hospitalId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    return { ...Hospitals(props.hospitalId) };
  },
});

export default ReportSummary;
